import React from 'react'

const tagManager = (props) => {
  // const GA_UID = 'G-TLJ4E7K1TL'
  return <>{/* <script async type="text/javascript" src={`https://www.googletagmanager.com/gtag/js?id=${GA_UID}`} /> */}</>
}

export default tagManager
